__turbopack_context__.v({
  "aiClose": "styles-module-scss-module__JbsJJG__aiClose",
  "card": "styles-module-scss-module__JbsJJG__card",
  "icon": "styles-module-scss-module__JbsJJG__icon",
  "label": "styles-module-scss-module__JbsJJG__label",
  "title": "styles-module-scss-module__JbsJJG__title",
});
